module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page--spaciouss"
  }, [_c('div', {
    staticClass: "plan__header"
  }, [_c('h1', {
    staticClass: "plan__page-title title--general title--1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isTrialExpired) ? _c('div', {
    staticClass: "plan__page-subtitle title--general"
  }, [_vm._v("To continue using Webkey sign up for a plan")]) : _vm._e()]), _vm._v(" "), (_vm.isMerchantEnabled) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.cloak",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "cloak": true
      }
    }]
  }, [_c('ul', {
    staticClass: "plan__grid"
  }, [_vm._l((_vm.plans), function(plan, index) {
    return _c('li', {
      staticClass: "plan__plan",
      style: ([plan.plan_name == _vm.curPlan ? {
        borderColor: _vm.colors[index],
        borderWidth: 4 + 'px',
        borderTopWidth: 10 + 'px'
      } : {
        borderColor: _vm.colors[index]
      }])
    }, [_c('h2', {
      staticClass: "title--general plan__title"
    }, [_c('div', {
      style: ({
        color: _vm.colors[index]
      })
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(plan.display_name) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "plan__tag_line"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(plan.tag_line) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "plan__description",
      attrs: {
        "align-center": "",
        "justify-space-around": "",
        "column": ""
      }
    }, [(_vm.isFreePlan(plan)) ? _c('div', [_c('div', {
      staticClass: "plan__price"
    }, [_vm._v("\n\t\t\t\t\t\t\tFree\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "plan__period"
    })]) : _c('div', [(plan.m_price) ? _c('div', [_c('div', {
      staticClass: "plan__price"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseCurrency")(plan.currency)) + " " + _vm._s(plan.m_price) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "plan__period"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tMonthly\n\t\t\t\t\t\t\t")])]) : _c('div', [_c('div', {
      staticClass: "plan__price"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseCurrency")(plan.currency)) + " " + _vm._s(plan.a_price) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "plan__period"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tAnnual\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(plan.description)
      }
    })]), _vm._v(" "), (plan.plan_name == _vm.curPlan && !_vm.isTrialExpired && _vm.status !== 'cancelled') ? _c('div', [(_vm.isTrialExpired || _vm.status === 'in_trial') ? _c('div', [_c('v-btn', {
      staticClass: "plan__button",
      attrs: {
        "color": "primary",
        "x-large": ""
      },
      on: {
        "click": function($event) {
          return _vm.redirectToSubscribe(plan)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tProceed to payment\n\t\t\t\t\t\t")])], 1) : _c('div', {
      staticClass: "plan__selected"
    }, [_vm._v("\n\t\t\t\t\t\tSELECTED\n\t\t\t\t\t")])]) : _c('div', [(!_vm.isFreePlan(plan)) ? _c('v-btn', {
      staticClass: "plan__button",
      attrs: {
        "color": "primary",
        "x-large": ""
      },
      on: {
        "click": function($event) {
          return _vm.redirectToSubscribe(plan)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tSubscribe now\n\t\t\t\t\t")]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.showEnterprisePlan()) ? _c('li', {
    staticClass: "plan__plan",
    staticStyle: {
      "border-top": "10px solid #145cff"
    }
  }, [_vm._m(0), _vm._v(" "), _c('v-layout', {
    staticClass: "plan__description",
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "column": ""
    }
  }, [_c('div', [_c('p', [_vm._v("Unlimited devices")]), _vm._v(" "), _c('p', [_vm._v("Headless Client App")]), _vm._v(" "), _c('p', [_vm._v("LAN Server Builds")]), _vm._v(" "), _c('p', [_vm._v("Pre-installed Webkey Client")])]), _vm._v(" "), _c('p'), _c('div', [_vm._v("Customisable solutions")]), _vm._v(" "), _c('div', [_vm._v(" for businesses")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('v-btn', {
    staticClass: "plan__button",
    attrs: {
      "color": "primary",
      "x-large": "",
      "href": "mailto:info@webkeyapp.com?subject=Subscription"
    }
  }, [_vm._v("\n\t\t\t\t\tContact us\n\t\t\t\t")])], 1) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title--general plan__title"
  }, [_c('div', {
    staticStyle: {
      "color": "#145cff"
    }
  }, [_vm._v("\n\t\t\t\t\t\tEnterprise\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "plan__tag_line"
  }, [_c('div', [_vm._v("For device providers")]), _vm._v(" "), _c('div', [_vm._v("and fleet managers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e320a6c8","hasScoped":false}!./app/components/plans/template.html
// module id = 402
// module chunks = 0